import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import CabListingCardHeaderUI from "../../../../../stories/components/cars/ResultsPage/CabListingCardHeader/CabListingCardHeaderUI";
import CabListItemUI from "../../../../../stories/components/cars/ResultsPage/CabListItem/CabListItemUI";
import OtherCabOptionsUI from "../../../../../stories/components/cars/ResultsPage/OtherCabOptions/OtherCabOptionsUI";
import {
  seoSelectedFilterSelector,
  dispatchSelector,
  seoVehicledataSelector,
  seoErrorSelector,
  rydeDispatchSearchIdSelector,
  commonSelector,
  aggregateRatingSelector,
  minFareSchemaSelector
} from "../../redux/selector";

import * as S from "./Listing.styles";
import NoCarsFoundUI from "../../../../../stories/components/cars/ResultsPage/NoCarsFound/NoCarsFoundUI";
import useNavigate from "../../../../hooks/useNavigate";
import { sourceSelector, destinationSelector, tripTypeSelector, homeHourlyRentalPackageSelector, osModalDetailsSelector, atModalDetailsSelector } from "../../../../common/redux/selector";
import { hourlyPackageDetailsSelector, showCabTypeDetailModalSelector } from "../../../SearchPage/redux/selector";
import CabHourlyCarouselUI from "../../../../../shared/containers/CabHourlyCarousel/CabHourlyCarouselUI";
import Popup from "../../../../../stories/core-components/PopupUI/PopupUI";
import { HR, PICKUP_LOC_DETAILS } from "../../../../../shared/config/constants";
import { UPDATE_PAYDATA, UPDATE_SELECTED_CAB } from "../../redux/seo-action-types";
import CabTypeModalDetails from "../../../../../shared/containers/CabTypeModalDetails/CabTypeModalDetails"
import { fetchModalInfoAndPackageDetails } from "../../../../../shared/common/redux/thunks";
import { gcTripCategoryScreen } from "../../../../../shared/config/omni";

interface IListing {}

const Listing: React.FC<IListing> = () => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const tripType = useSelector(tripTypeSelector);
  const hourlyPackageDetails = useSelector(hourlyPackageDetailsSelector);
  const selectedFilter = useSelector(seoSelectedFilterSelector);
  const dispatchSearchId = useSelector(dispatchSelector);
  const vehicle_data = useSelector(seoVehicledataSelector);
  const error = useSelector(seoErrorSelector);
  const rydeDispatchSearchId = useSelector(rydeDispatchSearchIdSelector);
  const source = useSelector(sourceSelector);
  const destination = useSelector(destinationSelector);
  const aggregateRating = useSelector(aggregateRatingSelector)
  const minFareSchema = useSelector(minFareSchemaSelector)
  const commonData = useSelector(commonSelector);
  const showCabTypeDetailModal = useSelector(showCabTypeDetailModalSelector)
  const hrDetails = useSelector(homeHourlyRentalPackageSelector)
  const osModalDetails = useSelector(osModalDetailsSelector)
  const atModalDetails = useSelector(atModalDetailsSelector)
  const {ryde_icon_url = ''} = commonData || {}
  const [showMore, toggleMore] = useState({});
  const [navigateTo] = useNavigate();
  const clearFilter = useCallback(() => {
    dispatch({
      type: "CLEAR_FILTER",
      filters: {},
    });
    navigateTo('srp', true);
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchModalInfoAndPackageDetails())
  }, [])

  const onPackageChange = useCallback(()=>{
    if (source?.name) {
      navigateTo("srp", true);
    }else{
      const title = PICKUP_LOC_DETAILS?.title;
      const content = PICKUP_LOC_DETAILS?.error;
      setErrorMessage({ title, content });
    }
  }, [])

  const naviagteToReview = useCallback(
    (selectedCab) => {
      dispatch({
        type: UPDATE_PAYDATA,
        paydata: {}
      });
      dispatch({
        type: UPDATE_SELECTED_CAB,
        selectedCab: { ...selectedCab, dispatchSearchId, rydeDispatchSearchId },
      });
      navigateTo("seo-to-review");
    },
    [dispatchSearchId,rydeDispatchSearchId]
  );

  const toggleFn = useCallback(
    (index) => {
      const updateMore = { ...showMore, [index]: !showMore[index] };
      toggleMore(updateMore);
    },
    [showMore]
  );

  const getModalDetails = useCallback(
    () => {
      let modalDetails = {}

      switch(tripType?.rf) {
        case "at" :
          modalDetails = atModalDetails?.airportModalData || {}
          break
  
        case "ow" :
        case "rt" :
          modalDetails = osModalDetails?.osModalData || {}
  
          break
  
        case "hr" : 
          modalDetails = hrDetails?.rentalModalDetails || {}
          break
      }
  
      return modalDetails
    },[tripType, atModalDetails, osModalDetails, hrDetails]
  )

  if (!vehicle_data || !vehicle_data.length) {
    if (Object.keys(selectedFilter)?.length) {
      return <NoCarsFoundUI title={error?.no_result_title} subtitle={error?.no_result_message} clearFilter={clearFilter} />;
    }
    if (Object.keys(error)?.length) {
      return <NoCarsFoundUI title={error?.no_result_title} subtitle={error?.no_result_message} no_result_image={error?.no_result_image} />;
    }
    return null;
  }
  let non_ryde_avail = false
  const isRental = tripType?.rf === HR
  return (
    <>
      {vehicle_data?.map(({ t_c, r_c_d,c_d=[] }, key) => {
        if(!r_c_d){
          return null
        }
        if(c_d && c_d.length && !non_ryde_avail){
          non_ryde_avail = true
        }
        return (
        <>
          <S.ListingCard key={`ryde${key}`}>
            <CabListingCardHeaderUI {...t_c} key={`rydeclKey${key}`} />
            {r_c_d.map((item, index) => {
           //   if (index >= 1 && !showMore[key]) return null;
              return (
                <CabListItemUI
                  {...item}
                  itemKey={item?.key}
                  key={`rydeclItem${index}`}
                  t_c={t_c}
                  c_d={c_d}
                  position={key}
                  commonData={commonData}
                  naviagteToReview={naviagteToReview}
                  ryde_icon_url={ryde_icon_url}
                />
              );
            })}
           
          </S.ListingCard>
          </>
        );
      }) || []}
        {non_ryde_avail ?   <h2 className="font18 fontMedium rubik appendTop28 appendBottom20">{`Other Cab Options from ${source?.name} to ${destination?.name}`}</h2>:null
      }
      {isRental ? (
        <>
          {hourlyPackageDetails?.rentalPackages?.length ? (
            <S.HrPackageCard>
              <CabHourlyCarouselUI data={hourlyPackageDetails?.rentalPackages} itemCount={6} onPackageChange={onPackageChange} invokedFor={gcTripCategoryScreen}/>
            </S.HrPackageCard>
          ) : null}
        </>
      ): null}
      {vehicle_data?.map(({ t_c, c_d = [] }, key) => {
        return (
          <S.ListingCard key={key}>
            <CabListingCardHeaderUI {...t_c} key={`clKey${key}`} />
            {c_d && c_d.map((item, index) => {
              if (index >= 1 && !showMore[key]) return null;
              return (
                <CabListItemUI
                  {...item}
                  itemKey={item?.key}
                  key={`clItem${index}`}
                  t_c={t_c}
                  c_d={c_d}
                  position={key}
                  commonData={commonData}
                  naviagteToReview={naviagteToReview}
                  ryde_icon_url={ryde_icon_url}
                  isSeo={true}
                  aggregateRating={aggregateRating}
                  minFareSchema={minFareSchema}
                />
              );
            }) || null}
            <OtherCabOptionsUI
              {...t_c}
              showMore={!!showMore[key]}
              toggleFn={toggleFn}
              index={key}
              cdLen={c_d?.length}
            />
          </S.ListingCard>
        );
      }) || []}
      {showCabTypeDetailModal ? (
        <CabTypeModalDetails item={getModalDetails()}/>
      ) : null}
      {errorMessage && <Popup title={errorMessage?.title} content={errorMessage?.content} onCloseClick={() => setErrorMessage(null)} size='medium' />}
    </>
  );
};

export default React.memo(Listing);
